module.exports = __webpack_public_path__ + "static/Lato-Hairline-482fe0a9e92d9c5ff7fec117ca54c8ae.woff";